import { ProductListing, type OnSaleItemInstance } from "./ProductListing";

/** The active catalog's on-sale items, one listing per item. */
export class ProductCatalog {
  readonly products: ProductListing[];
  private readonly byInstanceId: Map<number, ProductListing>;

  constructor(instances: readonly OnSaleItemInstance[]) {
    this.products = instances.map((instance) => new ProductListing(instance));
    this.byInstanceId = new Map(
      this.products.map((product) => [product.instanceId, product]),
    );
  }

  getMembershipItem(membershipTypeId: number) {
    return this.products.find(
      (item) =>
        item.isMembershipProduct() &&
        item.membershipTypeId === membershipTypeId,
    );
  }
  getGuestPrivsItem() {
    return this.products.find((item) => item.isGuestPrivsProduct());
  }
  getDamageWaiverItems() {
    return this.products.filter((item) => item.isDamageWaiverProduct());
  }
  getProductFromItemInstance(instanceId: number) {
    return this.byInstanceId.get(instanceId);
  }
}